import {
  DowncastAttributeEvent,
  DowncastDispatcher,
  Element,
  Item,
  ListEditing,
} from "ckeditor5";

import { doNothing } from "@examspark/common";

import { collectAncestors, removeClassesMatching } from "../../util/document";

import { ATTRIBUTE_NAME, CLASS_PREFIX, CLASS_REGEX } from "./utils";

type DowncastStrategy = Parameters<ListEditing["registerDowncastStrategy"]>[0];

export const createDowncastStrategy = () => {
  return {
    attributeName: ATTRIBUTE_NAME,
    scope: "item",
    setAttributeOnDowncast: doNothing,
  } satisfies DowncastStrategy;
};

export const createDefaultAttributeToAttributeDowncast = () => ({
  model: {
    key: ATTRIBUTE_NAME,
  },
  view: (value: string, _api: any, data: { item: Item }) => {
    if (data.item.hasAttribute("listItemId")) return;
    return {
      key: "class",
      value: `${CLASS_PREFIX}-${value}`,
    };
  },
});

export const downcastMarkedListItem = (dispatcher: DowncastDispatcher) =>
  dispatcher.on<DowncastAttributeEvent<Element>>(
    `attribute:listItemId`,
    (_e, { item }, { mapper, writer }) => {
      if (item == null) return;

      const viewElement = mapper.toViewElement(item);
      if (viewElement == null) return;

      const markName = item.getAttribute(ATTRIBUTE_NAME) as string | null;

      const listItemElement = viewElement.parent;

      if (!listItemElement?.is("view:element")) return;
      if (listItemElement.name !== "li") return;

      if (markName == null) {
        removeClassesMatching(CLASS_REGEX, listItemElement, writer);
        return;
      }

      const className = `${CLASS_PREFIX}-${markName}`;

      const isDescendentOfMarkedBlock = !!collectAncestors(item).find(
        (e) => e.getAttribute(ATTRIBUTE_NAME) === markName,
      );

      if (isDescendentOfMarkedBlock) {
        //
        // Handles the unnecessary mark attributes that are added to descendent
        // list items by the list upcast
        //
        writer.removeClass(className, listItemElement);
      } else {
        removeClassesMatching(CLASS_REGEX, listItemElement, writer);
        writer.addClass(className, listItemElement);
      }
    },
    { priority: "lowest" },
  );
